var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5006_9506",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07033 2.59961C4.81601 2.59959 4.57397 2.59956 4.37001 2.61623C4.1476 2.6344 3.89249 2.67678 3.63752 2.8067C3.28001 2.98886 2.98935 3.27952 2.80719 3.63703C2.67727 3.89201 2.63489 4.14711 2.61671 4.36952C2.60005 4.57348 2.60007 4.81553 2.6001 5.06985V18.9293C2.60007 19.1837 2.60005 19.4257 2.61671 19.6297C2.63489 19.8521 2.67727 20.1072 2.80719 20.3622C2.98935 20.7197 3.28001 21.0103 3.63752 21.1925C3.89249 21.3224 4.1476 21.3648 4.37001 21.383C4.57395 21.3996 4.81598 21.3996 5.07028 21.3996H18.9298C19.1841 21.3996 19.4262 21.3996 19.6301 21.383C19.8525 21.3648 20.1076 21.3224 20.3626 21.1925C20.7201 21.0103 21.0108 20.7197 21.1929 20.3622C21.3229 20.1072 21.3652 19.8521 21.3834 19.6297C21.4001 19.4257 21.4001 19.1837 21.4 18.9294V5.06985C21.4001 4.81555 21.4001 4.57347 21.3834 4.36952C21.3652 4.14711 21.3229 3.89201 21.1929 3.63703C21.0108 3.27952 20.7201 2.98886 20.3626 2.8067C20.1076 2.67678 19.8525 2.6344 19.6301 2.61623C19.4262 2.59956 19.1841 2.59959 18.9298 2.59961H5.07033ZM4.40011 4.49956C4.40011 4.44434 4.44488 4.39956 4.50011 4.39956H19.5001C19.5553 4.39956 19.6001 4.44433 19.6001 4.49956V13.8273L16.9999 11.2272L13.4999 14.7272L8.49993 9.72719L4.40011 13.827V4.49956ZM4.40011 16.3726V19.4995C4.40011 19.5548 4.44488 19.5995 4.50011 19.5995H19.5001C19.5553 19.5995 19.6001 19.5548 19.6001 19.4995V16.3729L16.9999 13.7728L13.4999 17.2728L8.49993 12.2728L4.40011 16.3726ZM17.2499 7.99999C17.2499 8.69034 16.6903 9.24998 15.9999 9.24998C15.3096 9.24998 14.7499 8.69034 14.7499 7.99999C14.7499 7.30963 15.3096 6.74999 15.9999 6.74999C16.6903 6.74999 17.2499 7.30963 17.2499 7.99999Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5006_9506)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9999,
    height: 23.9999,
    fill: "#171719"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardPicture);
export default __webpack_public_path__ + "static/media/electricboard-picture.dcbff5eff33db74d8523b31a7fd4bf9e.svg";
export { ForwardRef as ReactComponent };